import { api, getDevicesDetails } from '..'
import { TGatewayList } from 'shared/types'
import { uniqueArray } from 'utils/uniqueArray'
import { usePaginatedQuery } from 'hooks/usePaginatedQuery'

export type TLoraGatewayListWithDetails = Awaited<
  ReturnType<typeof getLoraGatewayList>
>

export const getLoraGatewayList = async (params?: Record<string, string>) => {
  const { items, ...data } = await api
    .get<TGatewayList>('/v1/lorawan/gateways', {
      params,
    })
    .then(({ data }) => data)

  const deviceIds = uniqueArray(items.map(item => item.gatewayId))

  const details = await getDevicesDetails(deviceIds)

  const newItems = items.map(item => {
    const device = details.get(item.gatewayId)!
    return { ...item, ...device }
  })

  return { ...data, items: newItems }
}
export const loraGatewayListQuery = (params?: Record<string, string>) => ({
  queryFn: () => getLoraGatewayList(params),
  queryKey: ['loraGateways', params],
})

export const useGetLoraGatewayList = (manualParams?: Record<string, string>) =>
  usePaginatedQuery(loraGatewayListQuery, manualParams)
